import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'lifedi-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, OnChanges {
  @Input() rowsData: any;
  @Input() columnsData: any[];

  dialogConfig = new MatDialogConfig();
  confirmDialog;
  page = 1;
  pageSize = 10;
  collectionSize: number;
  rows: any[];

  constructor(public matDialog: MatDialog) {
  }

  ngOnInit() {
    // // console.log(this.rowsData);
    this.collectionSize = this.rowsData.length;
    this.refresh();
  }

  ngOnChanges(val) {
    // // console.log("change detected");
    // // console.log(val);
    this.collectionSize = this.rowsData.length;
    this.refresh();
  }

  refresh() {
    this.rows = this.rowsData
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
}
